// src/components/admin/AdminDashboard.jsx
import React, { useContext } from 'react';
import {
	UserPlus,
	Users,
	ClipboardCheck,
	FileSpreadsheet,
	BarChart3,
	Upload,
	LogOut,
	ChevronRight,
} from 'lucide-react';
import { AppContext } from '../../App';

const AdminDashboard = () => {
	const { navigate, logout } = useContext(AppContext);

	return (
		<div className='h-full flex flex-col'>
			<header className='p-6 bg-gradient-to-r from-[#001E3C] to-[#000B18] border-b border-white/10'>
				<div className='flex justify-between items-center mb-6'>
					<div>
						<h2 className='text-xl font-black uppercase tracking-tight text-white'>
							Admin Dashboard
						</h2>
						<p className='text-xs text-white/60'>
							Harvard RMetaverse Management
						</p>
					</div>
					<button type="button" onClick={(e) => { e.preventDefault(); logout(); }}
						className='glass-card p-3 rounded-xl'>
						<LogOut className='w-5 h-5 text-white' />
					</button>
				</div>
			</header>

			<main className='flex-1 overflow-y-auto p-6 space-y-6 no-scrollbar'>
				<div
					onClick={(e) => {
						e.preventDefault();
						navigate('/admin/create-user');
					}}
					className='glass-card p-6 border-l-4 border-[#00F5FF] flex items-center gap-4 active:scale-95 transition-transform cursor-pointer'>
					<div className='w-12 h-12 bg-[#00F5FF]/10 rounded-2xl flex items-center justify-center'>
						<UserPlus className='w-6 h-6 text-[#00F5FF]' />
					</div>
					<div className='flex-1'>
						<h3 className='font-black text-lg text-white'>Create User</h3>
						<p className='text-xs text-white/60'>Register an agent or supervisor (choose type on the form)</p>
					</div>
					<ChevronRight className='text-white/30' />
				</div>

				<div
					onClick={(e) => {
						e.preventDefault();
						navigate('/admin/supervisor-management');
					}}
					className='glass-card p-6 border-l-4 border-[#E91E63] flex items-center gap-4 active:scale-95 transition-transform cursor-pointer'>
					<div className='w-12 h-12 bg-[#E91E63]/10 rounded-2xl flex items-center justify-center'>
						<Users className='w-6 h-6 text-[#E91E63]' />
					</div>
					<div className='flex-1'>
						<h3 className='font-black text-lg text-white'>Supervisor Management</h3>
						<p className='text-xs text-white/60'>Add supervisors, assign agents, enable or disable</p>
					</div>
					<ChevronRight className='text-white/30' />
				</div>

				<div
					onClick={(e) => {
						e.preventDefault();
						navigate('/admin/user-management');
					}}
					className='glass-card p-6 border-l-4 border-[#E91E63] flex items-center gap-4 active:scale-95 transition-transform cursor-pointer'>
					<div className='w-12 h-12 bg-[#E91E63]/10 rounded-2xl flex items-center justify-center'>
						<Users className='w-6 h-6 text-[#E91E63]' />
					</div>
					<div className='flex-1'>
						<h3 className='font-black text-lg text-white'>Agent Management</h3>
						<p className='text-xs text-white/60'>View and manage agents (enable, disable, assign bills)</p>
					</div>
					<ChevronRight className='text-white/30' />
				</div>

				<div
					onClick={(e) => {
						e.preventDefault();
						navigate('/admin/assign-bills');
					}}
					className='glass-card p-6 border-l-4 border-[#FFC107] flex items-center gap-4 active:scale-95 transition-transform cursor-pointer'>
					<div className='w-12 h-12 bg-[#FFC107]/10 rounded-2xl flex items-center justify-center'>
						<ClipboardCheck className='w-6 h-6 text-[#FFC107]' />
					</div>
					<div className='flex-1'>
						<h3 className='font-black text-lg text-white'>Assign Bills</h3>
						<p className='text-xs text-white/60'>
							Assign properties to agents
						</p>
					</div>
					<ChevronRight className='text-white/30' />
				</div>

				<div
					onClick={(e) => {
						e.preventDefault();
						navigate('/admin/bills-management');
					}}
					className='glass-card p-6 border-l-4 border-[#00E676] flex items-center gap-4 active:scale-95 transition-transform cursor-pointer'>
					<div className='w-12 h-12 bg-[#00E676]/10 rounded-2xl flex items-center justify-center'>
						<FileSpreadsheet className='w-6 h-6 text-[#00E676]' />
					</div>
					<div className='flex-1'>
						<h3 className='font-black text-lg text-white'>Bills Management</h3>
						<p className='text-xs text-white/60'>View all bills & statuses</p>
					</div>
					<ChevronRight className='text-white/30' />
				</div>

				<div
					onClick={(e) => {
						e.preventDefault();
						navigate('/admin/import-payments');
					}}
					className='glass-card p-6 border-l-4 border-[#00BCD4] flex items-center gap-4 active:scale-95 transition-transform cursor-pointer'>
					<div className='w-12 h-12 bg-[#00BCD4]/10 rounded-2xl flex items-center justify-center'>
						<Upload className='w-6 h-6 text-[#00BCD4]' />
					</div>
					<div className='flex-1'>
						<h3 className='font-black text-lg text-white'>Import external payments</h3>
						<p className='text-xs text-white/60'>Upload Excel to record payments made outside the app</p>
					</div>
					<ChevronRight className='text-white/30' />
				</div>

				<div
					onClick={(e) => {
						e.preventDefault();
						navigate('/admin-reports');
					}}
					className='glass-card p-6 border-l-4 border-[#9C27B0] flex items-center gap-4 active:scale-95 transition-transform cursor-pointer'>
					<div className='w-12 h-12 bg-[#9C27B0]/10 rounded-2xl flex items-center justify-center'>
						<BarChart3 className='w-6 h-6 text-[#9C27B0]' />
					</div>
					<div className='flex-1'>
						<h3 className='font-black text-lg text-white'>
							Reports & Analytics
						</h3>
						<p className='text-xs text-white/60'>Payments, deliveries, and summaries (scoped by role)</p>
					</div>
					<ChevronRight className='text-white/30' />
				</div>
			</main>
		</div>
	);
};

export default AdminDashboard;
